<template>
<div class="custom-block tip">
    <p class="custom-block-title">Importante</p>
    <p>Para más información sobre los errores generales y de negocio retornados en las respuestas de los servicios, consultar la documentación 
        <a href="/apis/documentation/apireferences/errorcodes/" class="">Códigos de Error</a>
    </p>
</div>
</template>
<script>
export default {
    name: 'TipError'
}
</script>